import { collectionApi } from '@shared/api/server'

import {
  UsersByAddressDTO,
  UsersReportRequestBody,
  UsersRequestBody
} from '../types'
import { transformBooleanGenderToString } from '../user.lib'
import { UserModel } from './user.model'

export interface IUsersRepository {
  getUsers(payload: UsersRequestBody): Promise<UsersByAddressDTO>
  getUsersReport(payload: UsersReportRequestBody): Promise<Blob>
}

export class UsersRepository implements IUsersRepository {
  async getUsers(payload: UsersRequestBody): Promise<UsersByAddressDTO> {
    const response = await collectionApi.getUsersAndAddressesInCircleAreaCall({
      cLat: payload.lat,
      cLong: payload.long,
      cRadius: payload.radius,
      gender: payload.gender,
      age: payload.age
      // messangers: payload.messangers
    })
    if (response.totalUsersCount === 0) {
      return {
        users: [],
        addresses: [],
        ageData: [],
        genderData: [],
        totalUsers: 0,
        totalAddresses: 0,
        isApproximateCount: false
      }
    }
    return {
      users: response.users.map(
        (user) =>
          new UserModel(
            user.id,
            user.phoneNumber,
            transformBooleanGenderToString(user.isMale),
            user.age ?? 0,
            user.point,
            user.sourceName,
            user.fullAddress,
            user.telegramId,
            user.isWhastsApp,
            user.isViber
          )
      ),
      addresses: response.addressInfos.map((address) => ({
        address: address.address,
        usersCount: address.entriesCount
      })),
      ageData: response.ageDiagramData,
      genderData: response.genderDiagramData,
      totalAddresses: response.totalAddressCount,
      totalUsers: response.totalUsersCount,
      isApproximateCount: response.isSearchedInTooBigCluster
    }
  }
  async getUsersReport(payload: UsersReportRequestBody): Promise<Blob> {
    const response = await collectionApi.getUsersReporCall({
      cLat: payload.lat,
      cLong: payload.long,
      cRadius: payload.radius,
      gender: payload.gender,
      age: payload.age
    })
    return response
  }
}
